import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Auto_Complete } from '../../../core/services/auto-complete';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MemberApiService } from '../../../core/services/api/member-api.service';
import { NotificationsService } from 'angular2-notifications';
import { ErrorHandlingService } from '../../../core/services/error-handling.service';
import { HttpService } from '../../../core/services/api/http.service';
import { AddThirdPartyProductRequest } from '../../models/add-third-party-product.interface';
import { finalize } from 'rxjs';
import { ThirdPartyFullObject } from '../../models/third-party.interface';
import { API_VERSIONS } from '../../consts/api-versions.const';

@UntilDestroy()
@Component({
  selector: 'app-assign-product-to-third-party',
  templateUrl: './assign-product-to-third-party.component.html',
  styleUrls: ['./assign-product-to-third-party.component.scss'],
})
export class AssignProductToThirdPartyComponent implements OnInit {
  user?: ThirdPartyFullObject;

  form!: FormGroup;
  isProductsLoading = false;
  isSubmitLoading = false;
  isSameProductError = false;

  productFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.PRODUCTS}/products`,
    true
  );
  constructor(
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private fb: FormBuilder,
    private memberApiService: MemberApiService,
    private notificationService: NotificationsService,
    private errorHandlingService: ErrorHandlingService,
    private _api: HttpService,
    private errHandle: ErrorHandlingService
  ) {}

  ngOnInit(): void {
    this.productFilter.searchBy = 'global_search';
    this.productFilter.options = {
      ...this.productFilter.options,
      include_atlantic_products: true,
    };
    this.user = this.config?.data?.user;
    this.initForm();
  }

  initForm() {
    const products = this.user?.third_party_info?.products || [];
    this.form = this.fb.group({
      product: [undefined, [Validators.required]],
    });
    this.form
      .get('product')
      ?.valueChanges.pipe(untilDestroyed(this))
      .subscribe((product) => {
        this.isSameProductError = !!products.find((p) => p.id === product.id);
      });
  }

  cancelClicked() {
    this.close();
  }

  saveClicked() {
    if (this.form.invalid || !this.form.touched || !this.user?.id) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitLoading = true;
    const payload: AddThirdPartyProductRequest = {
      third_party_id: this.user.third_party_info!.id,
      product_id: this.form.value?.product?.id,
    };
    this.memberApiService
      .addProduct(payload)
      .pipe(
        untilDestroyed(this),
        finalize(() => (this.isSubmitLoading = false))
      )
      .subscribe({
        next: () => {
          this.notificationService.success(
            '',
            'Product was assigned successfully'
          );
          this.close({ shouldReloadList: true });
        },
        error: (err) => {
          this.errorHandlingService.errorHandling(err);
        },
      });
  }

  public close(payload?: any) {
    this.ref.close(payload);
  }

  protected readonly Validators = Validators;
}
